// utils/generateFilters.js

export function generateFilters(variants) {
  const filterMap = new Map();

  const filterKeys = [
    'variant',
    'transmission',
    'body',
    'fuel',
    'drivetrain',
    'seats',
    'doors',
    'engine'
  ];

  variants.forEach(variant => {
    filterKeys.forEach(key => {
      if (variant[key] && variant[key].value) {
        if (!filterMap.has(key)) {
          filterMap.set(key, new Set());
        }
        variant[key].value.forEach(val => filterMap.get(key).add(val));
      }
    });
  });

  return Array.from(filterMap).map(([name, values]) => ({
    name,
    type: name === 'variant' ? 'radio' : 'radio',
    data: Array.from(values).map(value => ({
      value,
      displayValue: value
    }))
  }));
}